/* Stacks the page content inside the login layout's bar */
.content {
	@apply
	yst-w-full
	yst-flex
	yst-flex-col
	yst-items-center
	yst-space-y-6;
}

/* Logo connection with dotted line */
.logoConnection {
	@apply
	yst-flex
	yst-items-center
	yst-justify-center;
}

.logoBox {
	@apply
	yst-w-14
	yst-h-14
	yst-rounded-md
	yst-flex
	yst-items-center
	yst-justify-center
	yst-overflow-hidden
	yst-bg-white
	yst-border
	yst-border-slate-200
	yst-flex-shrink-0
	yst-mx-1;
}

.logoImage {
	@apply
	yst-w-full
	yst-h-full
	yst-object-contain
	yst-p-2;
}

.logoInitial {
	@apply
	yst-w-full
	yst-h-full
	yst-flex
	yst-items-center
	yst-justify-center
	yst-bg-primary-500
	yst-text-white
	yst-text-xl
	yst-font-bold;
}

.yoastLogoImage {
	@apply
	yst-w-8
	yst-h-8;
}

.connectionLine {
	@apply
	yst-w-6
	yst-border-t-4
	yst-border-dotted
	yst-border-slate-300;
}

/* Title */
.title {
	@apply
	yst-text-slate-800
	yst-text-center;
}

/* User card showing logged-in user */
.userCard {
	@apply
	yst-w-full
	yst-flex
	yst-items-center
	yst-gap-3
	yst-p-4
	yst-bg-slate-50
	yst-rounded-md
	yst-border
	yst-border-slate-200;
}

.userAvatar {
	@apply
	yst-w-10
	yst-h-10
	yst-text-slate-400
	yst-flex-shrink-0;
}

.userInfo {
	@apply
	yst-flex
	yst-flex-col
	yst-items-start
	yst-text-left
	yst-min-w-0;
}

.userName {
	@apply
	yst-font-medium
	yst-text-slate-800
	yst-text-sm
	yst-truncate
	yst-w-full;
}

.userEmail {
	@apply
	yst-text-slate-500
	yst-text-xs
	yst-truncate
	yst-w-full;
}

/* Error message */
.errorMessage {
	@apply
	yst-w-full
	yst-bg-red-50
	yst-border
	yst-border-red-200
	yst-text-red-700
	yst-px-4
	yst-py-3
	yst-rounded-md
	yst-text-sm
	yst-text-left;
}

/* Loading container */
.loadingContainer {
	@apply
	yst-flex
	yst-flex-col
	yst-items-center
	yst-justify-center
	yst-py-12;
}

/* Permissions section */
.permissionsSection {
	@apply
	yst-w-full
	yst-space-y-3
	yst-text-left;
}

.permissionsLabel {
	@apply
	yst-text-slate-600
	yst-text-sm
	yst-m-0;
}

.scopesList {
	@apply
	yst-list-none
	yst-p-0
	yst-m-0
	yst-space-y-2;
}

.scopeItem {
	@apply
	yst-flex
	yst-flex-row
	yst-items-start
	yst-gap-2;
}

.scopeIcon {
	@apply
	yst-w-4
	yst-h-4
	yst-text-primary-500
	yst-flex-shrink-0
	yst-mt-0.5;
}

.scopeText {
	@apply
	yst-flex
	yst-flex-col
	yst-gap-0.5;
}

.scopeTitle {
	@apply
	yst-text-slate-700
	yst-text-sm
	yst-font-medium;
}

.scopeDescription {
	@apply
	yst-text-slate-500
	yst-text-xs;
}

/* Action buttons - side by side */
.actions {
	@apply
	yst-w-full
	yst-flex
	yst-flex-row
	yst-gap-3;
}

.cancelButton {
	@apply
	yst-flex-1;
}

.authorizeButton {
	@apply
	yst-flex-1;
}

/* Legal notice - above buttons, left-aligned */
.legalNotice {
	@apply
	yst-w-full
	yst-text-xs
	yst-text-slate-500
	yst-text-left
	yst-m-0;
}

/* Redirect notice - below buttons, centered */
.redirectNotice {
	@apply
	yst-text-xs
	yst-text-slate-500
	yst-text-center
	yst-m-0;
}

/* Helper copy above the in-consent re-authentication form */
.reauthHelper {
	@apply
	yst-w-full
	yst-text-sm
	yst-text-slate-600
	yst-text-left
	yst-m-0;
}

/* Wrapper around LoginForm so it stretches the card width */
.reauthForm {
	@apply
	yst-w-full;
}

/* "Create an account" link below the in-consent re-authentication form */
.reauthSignup {
	@apply
	yst-w-full
	yst-text-sm
	yst-text-slate-600
	yst-text-center
	yst-m-0;
}
